import React from "react";
import style from "./TextH.module.scss";
import cls from "classnames";
export var TextH = function TextH(props) {
  var _props$readonlyStyle;
  return /*#__PURE__*/React.createElement("p", {
    style: (_props$readonlyStyle = props.readonlyStyle) !== null && _props$readonlyStyle !== void 0 ? _props$readonlyStyle : {},
    className: cls(style.textH, style[props.className], !props.expanded ? style.shrinked : "")
  }, props.head);
};